import { apiClient } from "./axios";

const bannerList = async ({ page }) => {
  try {
    const res = await apiClient.get(
      `/admin/v1/manage/banner/list?page=${page}`
    );
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return {
      data: res.data.data,
      count: res.data.total_count,
    };
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const contentList = async ({ last_time_stamp = 0, type }) => {
  try {
    const res = await apiClient.get(
      `/api/v1/content/list?last_time_stamp=${last_time_stamp}&type=${type}`
    );
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return {
      data: res.data.data,
    };
  } catch (error) {
    console.error('Error:', error);
    return { IsError: true };
  }
};

const contentDetail = async ({ id }) => {
  try {
    const res = await apiClient.get(`/api/v1/content/detail?content_id=${id}`);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return {
      data: res.data.data,
    };
  } catch (error) {
    console.error('Error:', error);
    return { IsError: true };
  }
}

const sequenceDetail = async ({ id }) => {
  try {
    const res = await apiClient.get(`/api/v1/content/sequence?sequence_id=${id}`);
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return {
      data: res.data.data,
    };
  } catch (error) {
    console.error('Error:', error);
    return { IsError: true };
  }
}

const contentHooks = {
  bannerList,
  contentList,
  contentDetail,
  sequenceDetail,
};

export default contentHooks;
